import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Home as HomeIcon,
  Plus,
  Calendar,
  User,
  Users
} from 'lucide-react';

const BottomNavigation = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home', icon: HomeIcon },
    { path: '/generate', label: 'Generate', icon: Plus },
    { path: '/groups', label: 'Groups', icon: Users },
    { path: '/plans', label: 'Plans', icon: Calendar },
    { path: '/profile', label: 'Profile', icon: User }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 z-50"
    >
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link 
              key={item.path} 
              to={item.path} 
              className="flex flex-col items-center space-y-1"
            >
              <Icon 
                className={`w-6 h-6 ${isActive ? 'text-blue-600' : 'text-gray-400'}`} 
              />
              <span 
                className={`text-xs ${isActive ? 'text-blue-600 font-medium' : 'text-gray-400'}`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </motion.div>
  );
};

export default BottomNavigation;
